import { FC, useEffect, useState } from 'react';
import { IHomePageVideoPopup } from 'base/interfacesV2/feature';
import { getHomePageVideoPopup } from 'base/servicesV2/feature';
import { IMediaPopupProps, MediaPopup } from '@base/common/MediaPopup';
import { isVideoUrl } from 'base/utils/file';
import { getModuleCode } from 'base/utils/features';
import { PopupsItem, StateType } from 'base/store/popupFixedStore';
import { observer, useStore } from 'base/store';

type ITransformedData = Omit<IMediaPopupProps, 'visible' | 'onCancel'>;

const transformData = (data: IHomePageVideoPopup): ITransformedData => {
    const {
        width,
        height,
        maskOpacity,
        resourceLink,
        backupResourceLink,
        redirectLink,
        cover,
        autoPlay,
        mute,
        moduleCode,
    } = data;

    const transformedData: ITransformedData = { width, height, maskOpacity };

    if (isVideoUrl(resourceLink)) {
        transformedData.video = {
            src: [resourceLink, backupResourceLink],
            autoPlay,
            muted: mute,
            poster: cover,
        };
    } else if (!!resourceLink) {
        transformedData.image = {
            src: resourceLink,
            href: redirectLink
        };
    }

    transformedData.trackData = {
        module: getModuleCode({ moduleId: 'homePageVideoPopup' }),
        targetType: 'popup',
        target: resourceLink,
        relTarget: resourceLink,
        position: 1,
        value: moduleCode
    };

    return transformedData;
};

const VideoPopup: FC = () => {
    const [data, setData] = useState<ITransformedData | null>();
    const [visible, setVisible] = useState<boolean>(false);
    const { popupFixedStore } = useStore();

    useEffect(() => {
        getHomePageVideoPopup().then(res => {
            if (res) {
                setData(transformData(res));
                popupFixedStore.changeState(StateType.Popup, PopupsItem.videoPopup, 'true')
            }
        });
    }, []);

    const videoPopupState = popupFixedStore.getTargetState(StateType.Popup, PopupsItem.videoPopup)

    useEffect(() => {
        if (data && !!popupFixedStore.state.popup) {
            if (popupFixedStore.checkDisPlayInOrder(StateType.Popup, PopupsItem.videoPopup)) {
                setVisible(true);
            }
        }

    }, [videoPopupState]);

    return !data || !(data.image || data.video) ? null : (
        <MediaPopup
            {...data}
            visible={visible}
            onCancel={() => setVisible(false)}
        />
    );
};

export default observer(VideoPopup);
